
import React from 'react';
import { Link } from 'react-router-dom';
import { openAxeptioCookies } from '@/utils/axeptio';

const Footer = () => {
  return (
    <footer className="bg-brand-dark text-white/80 pt-10 sm:pt-16 pb-6 sm:pb-8 mt-12 sm:mt-24">
      <div className="container">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 sm:gap-8 pb-12 border-b border-white/10">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src="/logo.svg"
                alt="FullBook"
                className="h-8 w-auto brightness-0 invert"
              />
            </Link>
            <p className="text-sm leading-relaxed text-white/65 max-w-[32ch] mb-6">
              Réservez, jouez, recommencez. La plateforme française pour les activités indoor entre amis, en Île-de-France.
            </p>
            <div className="flex gap-2.5">
              {/* Instagram */}
              <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/8 flex items-center justify-center text-white hover:bg-brand-primary transition-colors duration-200">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37Z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
              </a>
              {/* TikTok */}
              <a href="#" aria-label="TikTok" className="w-9 h-9 rounded-full bg-white/8 flex items-center justify-center text-white hover:bg-brand-primary transition-colors duration-200">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"/></svg>
              </a>
              {/* LinkedIn */}
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-full bg-white/8 flex items-center justify-center text-white hover:bg-brand-primary transition-colors duration-200">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/><rect width="4" height="12" x="2" y="9"/><circle cx="4" cy="4" r="2"/></svg>
              </a>
            </div>
          </div>

          {/* Découvrir */}
          <div>
            <h5 className="text-white font-semibold text-xs uppercase tracking-widest mb-4">Découvrir</h5>
            <ul className="space-y-2.5">
              <li><Link to="/search" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Toutes les activités</Link></li>
              <li><Link to="/bowling-paris" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Bowling</Link></li>
              <li><Link to="/karting-paris" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Karting</Link></li>
              <li><Link to="/escape-game-paris" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Escape Game</Link></li>
              <li><Link to="/padel-paris" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Padel</Link></li>
            </ul>
          </div>

          {/* FullBook */}
          <div>
            <h5 className="text-white font-semibold text-xs uppercase tracking-widest mb-4">FullBook</h5>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Comment ça marche</Link></li>
              <li><Link to="/account" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Mon compte</Link></li>
              <li><Link to="/blog" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="text-sm text-white/70 hover:text-brand-primary transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Nous contacter</Link></li>
            </ul>
          </div>

          {/* Pour les pros */}
          <div>
            <h5 className="text-white font-semibold text-xs uppercase tracking-widest mb-4">Pour les pros</h5>
            <ul className="space-y-2.5">
              <li><Link to="/pro" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Devenir partenaire</Link></li>
              <li><Link to="/pro-dashboard" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Espace pro</Link></li>
              <li><Link to="/pro#tarifs" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Tarifs</Link></li>
              <li><Link to="/faq" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Centre d'aide pro</Link></li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h5 className="text-white font-semibold text-xs uppercase tracking-widest mb-4">Légal</h5>
            <ul className="space-y-2.5">
              <li><Link to="/cgv" className="text-sm text-white/70 hover:text-brand-primary transition-colors">CGV</Link></li>
              <li><Link to="/cgu-pro" className="text-sm text-white/70 hover:text-brand-primary transition-colors">CGU Pro</Link></li>
              <li><Link to="/confidentialite" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Confidentialité</Link></li>
              <li><Link to="/mentions-legales" className="text-sm text-white/70 hover:text-brand-primary transition-colors">Mentions légales</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 pt-6 text-xs text-white/55">
          <div className="flex flex-col gap-1">
            <span>© {new Date().getFullYear()} FullBook SAS · Fait à Paris</span>
            <button
              onClick={openAxeptioCookies}
              className="text-left text-white/55 hover:text-brand-primary transition-colors"
            >
              Préférences cookies
            </button>
          </div>
          <div className="flex gap-5">
            <Link to="/confidentialite" className="hover:text-white transition-colors">Confidentialité</Link>
            <Link to="/mentions-legales" className="hover:text-white transition-colors">Mentions légales</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
